import {
    ALPHABETICAL_SORT,
    NEWEST_SORT,
    POPULARITY_SORT,
    PRICE_SORT,
    REVIEW_SORT,
    SEARCH_SORT,
} from '../../../../modules/sortAndFilter/patterns/commands';

/**
 * Refactor and move somewhere more useful.
 * @see https://app.clickup.com/t/8692xecxh
 */
export const sortCommands = {
    alphabeticalAZ: {
        type: 'alphabetical',
        keys: ALPHABETICAL_SORT.A_Z,
    },
    alphabeticalZA: {
        type: 'alphabetical',
        keys: ALPHABETICAL_SORT.Z_A,
    },
    newest: {
        type: 'newest',
        keys: NEWEST_SORT.NEWEST,
    },
    popularity: {
        type: 'popular',
        keys: POPULARITY_SORT.POPULAR,
    },
    priceLowToHigh: {
        type: 'price',
        keys: PRICE_SORT.LOW_HIGH,
    },
    priceHighToLow: {
        type: 'price',
        keys: PRICE_SORT.HIGH_LOW,
    },
    review: {
        type: 'review',
        keys: REVIEW_SORT.HIGH_LOW,
    },
    relevance: {
        type: 'relevance',
        keys: SEARCH_SORT.RELEVANCE,
    },
    filter: {
        type: 'yes',
    },
};
